module.exports = __webpack_public_path__ + "static/img/ua.cfa6b227.png";